export const PROFILE_V9_MAX_WIDTH = '1440px';

export const APPT_OPTIONS_KEYS = {
  RELATIONSHIP: 'relationship',
  PURPOSE: 'purpose'
};
